<cap-file-upload
  accept=".xls, .xlsx"
  styleClass="cap-button primary"
  [label]="'LeadPortal.lead.upload-button.title' | translate"
  [multiple]="false"
  (onFileChange)="loadFile({ file: $event[0] })">
</cap-file-upload>
